import instance from '@/services/repository';

const resource = '/subcontractors';
const employees = 'employees';

export default {
    get() {
        return instance.get(`${resource}`);
    },
    getSingle(id: string) {
        return instance.get(`${resource}/${id}`);
    },
    create(payload: any) {
        return instance.post(`${resource}`, payload);
    },
    update(payload: any) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(payload: any) {
        return instance.delete(`${resource}/${payload.id}`);
    },
    // employees
    getEmployeesBySubcontractorId(subcontractorId: string) {
        return instance.get(`${resource}/${subcontractorId}/${employees}`);
    },
    removeEmployee(subcontractorId: string, id: string) {
        return instance.delete(`${resource}/${subcontractorId}/employees/${id}`);
    },
    // files
    fileUpload(subcontractorId: string, payload: any) {
        const config: any = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        return instance.post(`${resource}/${subcontractorId}/upload`, payload, config);
    },
    fileDownload(subcontractorId: string, name: string) {
        const config: any = {
           responseType: 'arraybuffer',
        };

        return instance.get(`${resource}/${subcontractorId}/file/${name}`, config);
    },
    fileUpdate(subcontractorId: string, name: string) {
        const config: any = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        return instance.put(`${resource}/${subcontractorId}/file/${name}`, config);
    },
    fileDelete(subcontractorId: string, name: string) {
        return instance.delete(`${resource}/${subcontractorId}/file/${name}`);
    },
};
